import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './errors';

/**
 * The timeout(5000) + retry(1) that every Angular service repeated now lives
 * here once. The timeout is enforced in apiClient; the retry is enforced here.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Retrying a 401/403 just burns time; the answer won't change.
        if (error instanceof ApiError && error.isAuthFailure) return false;
        return failureCount < 1;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
});
